import React, { ReactNode, useEffect, useState } from "react";
import { getPagePermissionByUserName } from "../services/PageServie";
import { useSelector } from "react-redux";

interface PermissionWrapperProps {
  pageName: string;
  children: ReactNode;
}

const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  pageName,
  children,
}) => {
  const userName = useSelector((state: any) => {
    try {
      return state.auth.userSession.user.username;
    } catch (error) {
      return "";
    }
  });
  const [hasPermission, setHasPermission] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const userPermissions: any = await getPagePermissionByUserName(
          userName,
          pageName
        );
        setHasPermission(userPermissions.pagePermissions.length > 0);
      } catch (error) {
        // Handle errors, e.g., show an error message or redirect to an error page
        console.error("Error checking permissions:", error);
        setHasPermission(false);
      }
    };

    checkAccess();
  }, [userName, pageName]);

  if (hasPermission === null) {
    // Loading state
    return null; // or a loading spinner or message
  }

  return hasPermission ? (
    <>{children}</>
  ) : (
    <div>
      <h1>Permission Denied</h1>
      <p>You don't have access to view this page.</p>
      {/* You can redirect to another page or handle it according to your requirements */}
      <a href="/" className="ml-2">
        Go to - Home
      </a>
    </div>
  );
};

export default PermissionWrapper;
